import type { ReactNode } from 'react';
import { Chip } from './Chip.js';

/**
 * **`QuotaChip`**（§4.3 の 7 / D29 / D28）— 今月の残りメッセージ数。
 *
 * ## **円では見せない**（D28 / D29）
 *
 * **金額を受け取らない型にしてある** — 受け取れるようにすると、
 * **「開発中だけ円も出す」が本番に残る**。
 * **消費量の単位はターン（メッセージ）**である（D29）。
 *
 * ## 残りが少ないことを色だけで伝えない
 *
 * `status` の variant は色を持つが、**文言に数を出す**ので
 * **色が読めなくても意味が届く**（§2.6 規約3 と同じ思想）。
 */
export interface QuotaChipProps {
  /** **残りメッセージ数**（D29。**円ではない**） */
  readonly remaining: number;
  /** これを下回ったら注意の見た目にする */
  readonly warnBelow?: number;
}

export function QuotaChip({ remaining, warnBelow = 5 }: QuotaChipProps): ReactNode {
  return (
    <Chip variant="status" status={remaining <= warnBelow ? 'warn' : 'neutral'}>
      残り {remaining} 回
    </Chip>
  );
}
